module.exports = __webpack_public_path__ + "img/uart1.20233d48.png";